"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_SPECIALITY_DOCTOR_LIST = exports.GET_PAST_DOCTOR_LIST = exports.GET_MY_DOCTOR_LIST = exports.GET_FACILITY_DOCTOR_LIST = exports.GET_DOCTOR_LIST_SPECIALITY = exports.GET_DOCTOR_LIST_FACILITY = exports.GET_DOCTOR_LIST = exports.GET_DOCTOR_FILTER = exports.GET_DOCTOR_DETAILS = exports.GET_CMS_DOCTOR_DETAILS = exports.GET_ALL_SPECIALITY_LIST = exports.ADD_REMOVE_DOCTOR = void 0;
const GET_DOCTOR_FILTER = exports.GET_DOCTOR_FILTER = 'getDoctorFilter';
const GET_DOCTOR_LIST = exports.GET_DOCTOR_LIST = 'getDoctorList';
const GET_MY_DOCTOR_LIST = exports.GET_MY_DOCTOR_LIST = 'getMyDoctorList';
const GET_SPECIALITY_DOCTOR_LIST = exports.GET_SPECIALITY_DOCTOR_LIST = 'getSpecialityDoctorList';
const GET_FACILITY_DOCTOR_LIST = exports.GET_FACILITY_DOCTOR_LIST = 'getFacilityDoctorList';
const GET_ALL_SPECIALITY_LIST = exports.GET_ALL_SPECIALITY_LIST = 'getAllSpecialityList';
const GET_DOCTOR_DETAILS = exports.GET_DOCTOR_DETAILS = 'doctorDetails';
const ADD_REMOVE_DOCTOR = exports.ADD_REMOVE_DOCTOR = 'addRemoveDoctor';
const GET_PAST_DOCTOR_LIST = exports.GET_PAST_DOCTOR_LIST = 'getPastDoctorsList';
const GET_CMS_DOCTOR_DETAILS = exports.GET_CMS_DOCTOR_DETAILS = 'cmsDoctorDetails';
const GET_DOCTOR_LIST_SPECIALITY = exports.GET_DOCTOR_LIST_SPECIALITY = 'getDoctorListSpeciality';
const GET_DOCTOR_LIST_FACILITY = exports.GET_DOCTOR_LIST_FACILITY = 'getDoctorListFacility';